import dayjs from 'app/config/dayjsConfig';
import React, { FC, memo, ReactElement } from 'react';
import { useAppTranslation } from 'app/config/i18Config/hooks';
import { HistoryAction } from 'entities/History';
import { OpenValidationErrorActionNames } from 'entities/History/model/types';
import { actionTitleMapper } from '../utils/helpers/actionTitleMapper';
import { actionIconMapper } from '../utils/helpers/actionIconMapper';

interface HistoryActionRowProps {
  data: HistoryAction;
  loggedUserEmail: string | undefined;
}

export const HistoryActionRow: FC<HistoryActionRowProps> = memo((props) => {
  const {
    data: { actionName, actionData, createdAt, updatedAt },
    loggedUserEmail,
  } = props;

  const { t } = useAppTranslation('profile');

  const isErrorAction = Object.values(OpenValidationErrorActionNames).includes(actionName as OpenValidationErrorActionNames);

  const getActionTitle = (): ReactElement => {
    const { subject, action, object } = actionTitleMapper(actionName, actionData, t);

    const subjectName = subject === loggedUserEmail ? t('You') : subject;

    const layout = (): ReactElement => {
      return (
        <div className="font-normal text-sm flex flex-wrap gap-x-1">
          <span className="font-medium text-sm text-primaryLight break-words whitespace-normal max-w-full">{subjectName}</span>
          <span
            className={`${
              isErrorAction ? 'text-error font-semibold' : 'text-primaryLight'
            } text-sm break-words whitespace-normal max-w-full`}
          >
            {action}
          </span>
          <span className="text-accent text-sm break-words whitespace-normal max-w-full">{object}</span>
        </div>
      );
    };

    return layout();
  };

  const lastUpdateTime = dayjs(updatedAt || createdAt).fromNow();

  const actionIcon = actionIconMapper(actionName);

  return (
    <div className="flex items-center space-x-4">
      {actionIcon}
      <div className="flex flex-col">
        {getActionTitle()}
        <div className="text-sm text-grey">{lastUpdateTime}</div>
      </div>
    </div>
  );
});
